import { Service } from '../types';

export const MOCK_SERVICES: Service[] = [
  {
    id: 'svc-001',
    title: 'Roof Cleaning',
    slug: 'roof-cleaning',
    category: 'roof-cleaning',
    shortDesc: 'Professional soft-wash roof cleaning that removes moss, algae, and black streaks.',
    description: `Our professional roof cleaning service uses an eco-friendly soft-wash system that safely removes algae, moss, lichen, and black streaks without damaging your shingles. We treat the root cause — not just the symptoms — and apply a protective treatment that keeps your roof clean longer. Our process is safe for all roofing materials including asphalt shingles, tile, metal, and cedar shake.`,
    icon: 'Droplets',
    price: 'From $299',
    priceFrom: 299,
    features: [
      'Eco-friendly soft-wash system',
      'Removes moss, algae & lichen',
      'Safe for all roof types',
      'Extends roof life by 5+ years',
      'Protective treatment included',
      'Fully insured technicians',
      'Before & after documentation',
      '1-year algae-free guarantee',
    ],
    duration: '2–4 hours',
    warranty: '1-Year Clean Guarantee',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&auto=format&fit=crop&q=80',
    popular: true,
  },
  {
    id: 'svc-002',
    title: 'Roof Repair',
    slug: 'roof-repair',
    category: 'roof-repair',
    shortDesc: 'Expert repair for leaks, damaged shingles, flashing, and storm damage.',
    description: `From minor leaks to major storm damage, our expert repair technicians diagnose and fix issues fast. We handle missing or damaged shingles, flashing repairs, valley repairs, ridge cap replacement, pipe boot repairs, and more. Every repair comes with a written warranty and detailed photo documentation.`,
    icon: 'Wrench',
    price: 'From $199',
    priceFrom: 199,
    features: [
      'Same-day emergency repairs',
      'Storm damage specialists',
      'Insurance claim assistance',
      'All materials warranted',
      'Photo documentation',
      'Written repair guarantee',
      'Flashing & valley repairs',
      'Free re-inspection at 30 days',
    ],
    duration: '1–6 hours',
    warranty: '5-Year Repair Warranty',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&auto=format&fit=crop&q=80',
    popular: true,
  },
  {
    id: 'svc-003',
    title: 'Roof Replacement',
    slug: 'roof-replacement',
    category: 'roof-replacement',
    shortDesc: 'Full roof replacement with premium materials and lifetime workmanship warranty.',
    description: `When repairs aren't enough, our full roof replacement service delivers a beautiful, durable new roof that protects your home for decades. We offer a wide selection of premium shingles, tiles, and metal roofing systems. Our GAF Master Elite certified crews complete most replacements in 1–2 days with minimal disruption.`,
    icon: 'Home',
    price: 'From $4,500',
    priceFrom: 4500,
    features: [
      'GAF Master Elite Certified',
      'Premium material selection',
      'Complete tear-off & disposal',
      'Deck inspection & repair',
      'Lifetime workmanship warranty',
      'Manufacturer warranty transfer',
      'Energy-efficient options',
      'Financing available',
    ],
    duration: '1–3 days',
    warranty: '10-Year Workmanship + 50-Year Materials',
    image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&auto=format&fit=crop&q=80',
    popular: false,
  },
  {
    id: 'svc-004',
    title: 'Commercial Roofing',
    slug: 'commercial-roofing',
    category: 'commercial',
    shortDesc: 'Flat roof, TPO, EPDM, and commercial metal roofing systems for businesses.',
    description: `Our commercial division specializes in flat roofing systems including TPO, EPDM, modified bitumen, and built-up roofing. We also install and maintain commercial metal roofs, skylights, and drainage systems. We work around your business schedule to minimize downtime.`,
    icon: 'Building2',
    price: 'Custom Quote',
    priceFrom: 0,
    features: [
      'TPO, EPDM & modified bitumen',
      'Commercial metal roofing',
      'Preventive maintenance plans',
      'Emergency response 24/7',
      'OSHA-compliant crews',
      'Project management included',
      'Detailed inspection reports',
      'Multi-location contracts',
    ],
    duration: 'Project-dependent',
    warranty: '20-Year Commercial Warranty',
    image: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=800&auto=format&fit=crop&q=80',
    popular: false,
  },
  {
    id: 'svc-005',
    title: 'Emergency Roofing',
    slug: 'emergency-roofing',
    category: 'emergency',
    shortDesc: '24/7 emergency roof tarping and temporary repairs — we respond within 2 hours.',
    description: `When disaster strikes, we respond fast. Our 24/7 emergency team provides immediate tarping, temporary repairs, and water mitigation to stop damage from spreading. We work with all major insurance companies and provide detailed documentation for claims. Average response time: under 2 hours.`,
    icon: 'AlertTriangle',
    price: 'From $149',
    priceFrom: 149,
    features: [
      '24/7/365 availability',
      '< 2 hour response time',
      'Emergency tarping',
      'Temporary waterproofing',
      'Insurance documentation',
      'Direct insurer billing',
      'Storm damage assessment',
      'Water mitigation referral',
    ],
    duration: '1–3 hours (emergency)',
    warranty: '90-Day Emergency Repair',
    image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800&auto=format&fit=crop&q=80',
    popular: false,
  },
  {
    id: 'svc-006',
    title: 'Roof Inspection',
    slug: 'roof-inspection',
    category: 'inspection',
    shortDesc: 'Comprehensive 25-point inspection with detailed report and photo documentation.',
    description: `Our thorough 25-point roof inspection identifies current and potential issues before they become costly problems. Perfect for home buyers, sellers, or homeowners who just want peace of mind. Includes a detailed written report with color photos and repair recommendations.`,
    icon: 'Search',
    price: '$149',
    priceFrom: 149,
    features: [
      '25-point inspection checklist',
      'Drone-assisted assessment',
      'Color photo documentation',
      'Detailed written report',
      'Repair cost estimates',
      'Maintenance recommendations',
      'Transferable for home sales',
      'Digital report delivery',
    ],
    duration: '1–2 hours',
    warranty: 'N/A',
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&auto=format&fit=crop&q=80',
    popular: false,
  },
  {
    id: 'svc-007',
    title: 'Gutter Cleaning',
    slug: 'gutter-cleaning',
    category: 'gutter-cleaning',
    shortDesc: 'Full gutter cleaning, flushing, and minor repairs to protect your foundation.',
    description: `Clogged gutters cause roof rot, foundation damage, and basement flooding. Our gutter cleaning service removes all debris, flushes downspouts, checks hangers, and performs minor repairs. Available as a one-time service or on a seasonal maintenance schedule.`,
    icon: 'Waves',
    price: 'From $99',
    priceFrom: 99,
    features: [
      'Complete debris removal',
      'Downspout flushing',
      'Hanger & seal inspection',
      'Minor repair included',
      'Gutter guard installation',
      'Seasonal contracts available',
      'Before & after photos',
      'Debris bagged & removed',
    ],
    duration: '1–3 hours',
    warranty: '6-Month Clean Guarantee',
    image: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=800&auto=format&fit=crop&q=80',
    popular: false,
  },
];
